import { gql } from "@apollo/client"

const GET_SITE_DATA_LESSONS_SUMMARY = gql`
  query ($clientId: ID!) {
    dataLessonsSummary(client_id: $clientId) {
      data_age
      imported_at
      total
      sync_count
      custom_count
      missing_teacher_count
    }
  }
`

export { GET_SITE_DATA_LESSONS_SUMMARY }
